export default __webpack_public_path__ + "static/media/86.0d0b5992.jpeg";